export function log<T>(caller: string, message: string, data?: T) {
  console.log(`[${caller}] ${message}`, data ?? "");
}
